











































































































































import { Vue, Component } from "vue-property-decorator";
import { required, maxLength, url } from "vuelidate/lib/validators";
import { CompanyInformationPayload } from "../types";
import { Action, namespace } from "vuex-class";
import { AxiosError } from "axios";
import { errorParser } from "@/axios/utils/errorParser";
import { User } from "@/modules/auth/types";
import router from "@/router";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

const ActivationNamespace = namespace("activation");
const Auth = namespace("auth");

Vue.component("v-select", vSelect);

@Component({})
export default class BillingInfo extends Vue {
  @ActivationNamespace.Getter("getZipcode") zipcode;
  @ActivationNamespace.Getter("getCity") city;
  @ActivationNamespace.Getter("getAddressLine1") addressLine1;
  @ActivationNamespace.Getter("getAddressLine2") addressLine2;
  @ActivationNamespace.Getter("getWebsiteUrl") websiteUrl;
  @ActivationNamespace.Getter("getCountry") country;
  @ActivationNamespace.Getter("getBillingContactName") billingContactName;
  @ActivationNamespace.Getter("getBillingContactEmail") billingContactEmail;
  @ActivationNamespace.Getter("getName") name;

  @Action("activation/updateBillingInfo") updateBillingInfo!: (
    payload: CompanyInformationPayload
  ) => Promise<{}>;
  @Auth.Getter("getUser") user!: User;

  loading = false;
  error = "";
  countries = [];
  companyInformationForm = {
    zipcode: null,
    city: "",
    addressLine1: "",
    addressLine2: "",
    websiteUrl: "",
    country: "",
    billingContactName: "",
    billingContactEmail: "",
    name: "",
  };

  async mounted() {
    this.companyInformationForm.zipcode = this.zipcode;
    this.companyInformationForm.city = this.city;
    this.companyInformationForm.addressLine1 = this.addressLine1;
    this.companyInformationForm.websiteUrl = this.websiteUrl;
    this.companyInformationForm.country = this.country;
    this.companyInformationForm.billingContactName = this.billingContactName;
    this.companyInformationForm.billingContactEmail = this.billingContactEmail;
    this.companyInformationForm.name = this.name;
    this.companyInformationForm.addressLine2 = this.addressLine2;

    // Fetch supported countries
    this.countries = await fetch("https://assets.orbaone.com/api/countries")
      .then(async (response) => {
        const res = await response.json();
        return res;
      })
      .then((data) => data);
  }

  handleCountryChange(selected) {
    this.companyInformationForm.country = selected.name;
  }

  submitForm() {
    this.loading = true;
    this.updateBillingInfo({
      zipcode: this.companyInformationForm.zipcode,
      city: this.companyInformationForm.city,
      addressLine1: this.companyInformationForm.addressLine1,
      addressLine2: this.companyInformationForm.addressLine2,
      websiteUrl: this.companyInformationForm.websiteUrl,
      country: this.companyInformationForm.country,
      billingContactName: this.user.firstName + " " + this.user.lastName,
      billingContactEmail: this.user.email,
      name: this.companyInformationForm.name,
    })
      .then(() => {
        this.loading = false;
        router.push({ name: "select-plan" });
      })
      .catch((err: AxiosError) => {
        this.error = errorParser(err);
        this.loading = false;
        this.$notify({
          group: "error",
          title: "Error",
          text: "Failed to update company information",
        });
      });
  }

  validations() {
    return {
      companyInformationForm: {
        zipcode: {
          maxLength: maxLength(10),
          required,
        },
        city: {
          required,
        },
        addressLine1: {
          required,
        },
        websiteUrl: {
          url,
        },
        country: {
          required,
        },
        name: {
          required,
        },
      },
    };
  }
}
